import React from "react";
import "./CredentialPoints.css";
import { Avatar, AvatarGroup } from "@mui/material";

const VISIBLE_AVATAR_COUNT = 3;
const PLACEHOLDER_AVATARS = [undefined, undefined, undefined];

export const CredentialPoints = ({ points = [] }) => {
  if (!points?.length) return null;

  return (
    <div className="bs__point_creds_parent_container">
      <div className="bs__point_creds_tier_right">
        {points.map((point, i) => {
          const isStartBadge = i === 0;
          const isEndBadge = i === points.length - 1;
          const displayedAvatars = point?.avatars?.length
            ? point.avatars.slice(0, VISIBLE_AVATAR_COUNT)
            : PLACEHOLDER_AVATARS;

          return (
            <div key={point._id || i} className="bs__point_creds_tier_step">
              <div className="bs__point_creds_tier_badge">
                <div className="bs__point_creds_tier_badge_border"></div>
                <img
                  className="bs__point_creds_tier_badge_img"
                  src={point?.badgeImage}
                  alt=""
                />
                <small className="bs__point_creds_tier_badge_text">
                  {point.badgeName}
                </small>
              </div>
              <div
                className={[
                  "bs__point_creds_tier_tasks_count",
                  isStartBadge ? "is-start" : "",
                  isEndBadge ? "is-end" : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                <div className="bs__point_creds_tier_task_count_zebra">
                  {new Array(50).fill(0).map((_, index) => (
                    <div key={index}></div>
                  ))}
                </div>
                <p style={{ color: "#fff" }}>
                  {point?.valueThreshold} points
                </p>
              </div>
              <div className="bs__point_creds_avatars">
                <AvatarGroup max={displayedAvatars.length}>
                  {displayedAvatars.map((avatar, avatarIndex) => (
                    <Avatar
                      key={avatarIndex}
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "none",
                      }}
                      alt=""
                      src={avatar}
                    />
                  ))}
                </AvatarGroup>
                <span className="bs__point_creds_task_badge_user_text">
                  {point?.label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
